import { persistentAtom } from './persistence';
import type { Operator } from '@/data/operator';

/**
 * Settings store - form data that goes together
 * All persist to localStorage
 */
export const $assignment = persistentAtom<string>(
  'assignment',
  'Default Assignment',
);

export const $date = persistentAtom<string>(
  'date',
  new Date().toISOString().split('T')[0]!,
);

export const $myCallsign = persistentAtom<string>('callsign', '0');

export const $defaultFrequency = persistentAtom<string>('frequency', '14.070');

export const $currentOperator = persistentAtom<Operator>('operator', {
  id: 'unknown',
  name: 'Unknown Operator',
});
